export const baseApis = {
  totalLeaveEmployees: '/total-leave/employees/v1',
} as const;

export const endpoints = {
  paymentPreferences: '/payment-preferences',
} as const;
